import {TariffsController} from "../tariffs_controller";

export default class extends TariffsController {
  static targets = [
    'is_manual',
    "from_city",
    "to_city",
    "from_city_id",
    "to_city_id"
  ]

  newTaxiForm(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");
    this._openModalForm(url);
  }

  onSuccess(event) {
    const [data, status, xhr] = event.detail;
    if (data) {
      super._successNotify(data.notification_title, data.notification_message);
      super._hideOrUpdateModalContent(window.layout_modal_md, data);
      // reload current page
      window.location.reload();
    }
  }

  onError(event) {
    const [data, status, xhr] = event.detail;
    if (data) {
      super._errorNotify(data.notification_title, data.notification_message);
      window.layout_modal_md.setContent(data.form_content)
    }
  }

  updateCurrencyFields(event) {
    const currency = event.currentTarget.value;
    const currency_field = document.getElementById("transport_service_price_currency");
    console.log(currency_field);
    currency_field.innerHTML = currency;
  }
}